import VectorClass, * as VectorModule from './../../node_modules/ol/source/Vector.js';

class Vector extends VectorClass {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in VectorModule) {
    if (key !== "default") {
        Vector[key] = VectorModule[key];
    }
}

export default Vector;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/source/Vector.js';